import { makeAutoObservable, runInAction } from 'mobx';
import { Match } from 'navigo';

import { AuthStore } from 'stores/users/AuthStore';

import { serverUri } from 'utils/config';
import { nullsToUndefined } from 'utils/nullsToUndefined';
import { IRouteStore } from 'stores/RouteStore';
import { HttpException } from 'utils/types';
import { createForm } from 'forms/requestAccessForm';

type RequestStatus = 'not sent' | 'sending' | 'error' | 'sent';

export class RequestAccessPageStore {
  private token: string = '';
  form = createForm();
  errorMessage: string = '';
  status: RequestStatus = 'not sent';

  constructor(private readonly authStore: AuthStore, private readonly routeStore: IRouteStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    const token = match?.data?.token;
    if (token) {
      this.token = token;
    }
    this.status = 'not sent';
  }

  async requestAccess() {
    this.status = 'sending';
    const { message } = this.form.values();
    try {
      const response = await this.authStore.fetchWithAuth(
        `${serverUri}/job/${encodeURIComponent(this.token)}/request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            message,
          }),
        }
      );
      if (!response.ok) {
        const exception: HttpException = nullsToUndefined(await response.json());
        console.error(exception.message);
        runInAction(() => {
          this.status = 'error';
          this.errorMessage = `Unable to send access request. ${exception.message} Please, try again.`;
        });
        return;
      }
      runInAction(async () => {
        this.status = 'sent';
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.status = 'error';
        this.errorMessage = `Unable to send access request. ${
          error instanceof Error ? ` ${error.message}` : ''
        } Please, try again.`;
      });
    }
  }
}
